// Copyright © 2022 Vewd Software AS.
//
// This file is part of Vewd Cloud,
// and includes Vewd Confidential Information.
// Distribution is strictly prohibited without Vewd's written consent.
import PropTypes from "prop-types";

import { Button, ButtonsWrapper, Info } from "components/elements";
import { WarningModal } from "components/modals";
import { useDeleteManifest } from "hooks/manifests";
import { trans } from "src/translations";

import styles from "./ManifestRemoveModal.scss";

const HANDLE_REFETCH_DEFAULT = () => {};

export const ManifestRemoveModal = ({
  id,
  isOpen,
  onClose,
  onRefetch = HANDLE_REFETCH_DEFAULT,
}) => {
  const { mutate, isPending, error } = useDeleteManifest(id);

  const handleClose = () => onClose();
  const handleDelete = () =>
    mutate(id, {
      onSuccess: () => {
        onRefetch();
        onClose();
      },
    });

  return (
    <WarningModal
      actions={
        <ButtonsWrapper position="modal">
          <Button type="normal" onClick={handleClose}>
            {trans.CANCEL()}
          </Button>
          <Button
            type="red"
            onClick={handleDelete}
            processing={isPending}
            disabled={isPending}
          >
            {trans.APP_DETAILS_MANIFEST__REMOVE_CONFIRM_BUTTON()}
          </Button>
        </ButtonsWrapper>
      }
      isOpen={isOpen}
      onClose={handleClose}
      size="medium"
      title={trans.WARNING()}
    >
      <p className={styles.removeModalText}>
        {trans.APP_DETAILS_MANIFEST__REMOVE_MESSAGE()}
      </p>
      {error && <Info type="error">{error.message}</Info>}
    </WarningModal>
  );
};

ManifestRemoveModal.propTypes = {
  id: PropTypes.string,
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  onRefetch: PropTypes.func,
};
